module.exports = __webpack_public_path__ + "static/media/11 - Genesis Owusu - Wit' Da Team.b6595f49.mp3";